import React, { ReactElement } from 'react';
import MuiFormHelperText, { FormHelperTextProps as MuiFormHelperTextProps } from '@mui/material/FormHelperText';
import { BpDesignSystem } from '../../types';
import { Collapse, CollapseProps } from '../Collapse/Collapse';

export type FormHelperTextProps = BpDesignSystem.PropsWithChildren<
  Pick<BpDesignSystem.InputProps, 'helperText' | 'errorText' | 'error' | 'disabled'> & {
    id?: string;
    slotProps?: {
      collapse?: Omit<CollapseProps, 'children'>;
      helperText?: MuiFormHelperTextProps;
    };
    component?: React.ElementType;
  }
>;

export const FormHelperText: React.FC<FormHelperTextProps> = ({
  error,
  id,
  dataTest,
  errorText,
  helperText,
  children,
  slotProps,
  disabled,
  sx,
  component,
  ...rest
}: FormHelperTextProps): ReactElement => {
  const show = (!!error && !!errorText) || !!children || !!helperText;
  return (
    <Collapse in={show} unmountOnExit {...slotProps?.collapse}>
      <MuiFormHelperText
        error={!!error}
        disabled={disabled}
        data-test={dataTest}
        component={component}
        id={id ?? dataTest}
        sx={{ marginLeft: 0, ...sx }}
        {...rest}
        {...slotProps?.helperText}
      >
        {getHelperText({
          error,
          helperText,
          errorText,
          children
        })}
      </MuiFormHelperText>
    </Collapse>
  );
};

const getHelperText = (props: FormHelperTextProps): React.ReactNode => {
  if (!!props.error && props.errorText) {
    return props.errorText;
  }
  return props.helperText || props.children;
};
